<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <ng-container *ngIf="!isOffline()">
                <mat-icon svgIcon="save-error" />
            </ng-container>
            <div class="dialog-title">
                {{ 'autosave.error.dialog.title' | translate }}
            </div>
            <div class="dialog-message">
                <div>{{ 'autosave.error.dialog.message.1' | translate }}</div>
                <div>{{ 'autosave.error.dialog.message.2' | translate }}</div>
            </div>
            <div class="buttons-container">
                <div class="create button" (click)="sendReport()" [ngClass]="{ disabled_button: isOffline() }">
                    {{ 'autosave.error.dialog.button.send' | translate }}
                </div>
                <div class="cancel button" (click)="close()">
                    {{ 'autosave.error.dialog.button.close' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
